(function () {
  'use strict';

  class CountdownTimerPAB extends HTMLElement {
    connectedCallback() {
      this.daysEl = this.querySelector('[data-pab-days]');
      this.hoursEl = this.querySelector('[data-pab-hours]');
      this.minutesEl = this.querySelector('[data-pab-minutes]');
      this.secondsEl = this.querySelector('[data-pab-seconds]');

      this.endTime = this.resolveEndTime();
      if (!this.endTime) return;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    resolveEndTime() {
      const mode = this.dataset.mode || 'session';

      if (mode === 'fixed' && this.dataset.endDate) {
        const parsed = new Date(this.dataset.endDate).getTime();
        return isNaN(parsed) ? null : parsed;
      }

      // Session mode: countdown restarts each visit, persisted in
      // sessionStorage so it doesn't reset on every page navigation.
      const hours = parseFloat(this.dataset.durationHours) || 6;
      const storageKey = 'pab-countdown-end';
      let stored = null;
      try {
        stored = window.sessionStorage.getItem(storageKey);
      } catch (e) {
        stored = null;
      }

      if (stored && Number(stored) > Date.now()) {
        return Number(stored);
      }

      const end = Date.now() + hours * 60 * 60 * 1000;
      try {
        window.sessionStorage.setItem(storageKey, String(end));
      } catch (e) {
        /* sessionStorage unavailable, timer still works for this page view */
      }
      return end;
    }

    tick() {
      const remaining = Math.max(0, this.endTime - Date.now());

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.closest('.pab').style.display = 'none';
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  if (!customElements.get('countdown-timer-pab')) {
    customElements.define('countdown-timer-pab', CountdownTimerPAB);
  }
})();
